export const getRecentageTitle = (startRange, endRange) => {
  if (startRange && endRange === 100) {
    return `${startRange}% and more`;
  }

  if (startRange && endRange) {
    return `${startRange}-${endRange}%`;
  }

  return `${startRange}%`;
};
